var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"name":"cart","width":"100%","height":"auto","scrollable":true,"adaptive":true,"transition":"fade-down","classes":"","clickToClose":true},on:{"before-close":_vm.beforeClose}},[_c(_vm.cartComponent,{tag:"component"})],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6dfc9ac2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./_js/components/shop/Cart.vue
// module id = 98
// module chunks = 0